import { useState,useEffect } from 'react';
import './App.css';
import Home from './components/Home';
import Navbar from './components/Navbar';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import VedioPlayer from './components/VedioPlayer';
import WorkingonIt from './components/WorkingonIt';
import { HomeIcon } from '@heroicons/react/20/solid';
import ChannelDetails from './components/sub-components/ChannelDetails';
import SidebarAttack from './components/side-components/SidebarAttack';
import UserDetailFrom from './components/utility-Components/UserDetailForm';
import SubscriptionPage from './components/side-components/Subscription';
import WatchLater from './components/side-components/WatchLater';
import WatchHistory from './components/side-components/WatchHistory';
import Settings from './components/utility-Components/Setting';
import InitialPopup from './components/side-components/InitialPopup';
import FavoriteVideos from './components/side-components/Favorite';
import AboutPage from './components/sub-components/About';
import PageNotFound from './components/sub-components/PageNotFound';
import Contact from './components/sub-components/Contact';


function App() {

  const [selectedCategory, setselectedCategory] = useState("All");
  const [isDrawerVisible,setIsDrawerVisible ] = useState(false);
  const [PopupVisible, setPopupVisible] = useState(false);
  const [userDetails,setUserDetails] = useState({
    "watchLater" : [],
    "watchHistory" : [],
    "favorite" : [],
    "details" : null,
    "name" : null,
    "Uimage" : null,
    "subscription" : [],
    "currDate" : new Date(),
    'totalRequest': 0
  
  })
  const [blur , setBlur] = useState("OFF");
  const [databaseDataLength, setDatabaseDataLength] = useState(0);


  // ------------------


  const [page, setPage] = useState(1);
  const [Loading, setLoading] = useState(true);
  const [VedioArr, setVedioArr] = useState([])
  const [AllFetchedData, setAllFetchedData] = useState([]);
  const [displayName, setDisplayName] = useState(false)


  // localStorage.setItem("userDetails", userDetails )
  // let data = JSON.parse(localStorage.getItem("userDetails"));
  // console.log(data)

  

 

  useEffect(()=>{

    let data = JSON.parse(localStorage.getItem("userDetails"))
    if(!data)
      {
        localStorage.setItem("userDetails", JSON.stringify(userDetails) )  
      }
      else{
        // console.log("item already present");
      
      }

  },[])

  

  return (
   <>
   <BrowserRouter>

      <Navbar displayName={displayName} setDisplayName={setDisplayName} VedioArr={VedioArr} setVedioArr={setVedioArr} setAllFetchedData={setAllFetchedData} AllFetchedData={AllFetchedData} page={page} setPage={setPage} setLoading={setLoading} Loading={Loading} databaseDataLength={databaseDataLength} setDatabaseDataLength={setDatabaseDataLength} selectedCategory={selectedCategory} setselectedCategory={setselectedCategory} setBlur={setBlur} userDetails={userDetails} setUserDetails={setUserDetails}/>
      <SidebarAttack setIsDrawerVisible={setIsDrawerVisible} isDrawerVisible={isDrawerVisible} userDetails={userDetails} setPopupVisible={setPopupVisible} setUserDetails={setUserDetails}/>
      
      <Routes>
          <Route path='/' element={<Home displayName={displayName} setDisplayName={setDisplayName} VedioArr={VedioArr} setVedioArr={setVedioArr} setAllFetchedData={setAllFetchedData} AllFetchedData={AllFetchedData} page={page} setPage={setPage} setLoading={setLoading} Loading={Loading}   databaseDataLength={databaseDataLength} setDatabaseDataLength={setDatabaseDataLength}  selectedCategory={selectedCategory} setselectedCategory={setselectedCategory} blur={blur} setIsDrawerVisible={setIsDrawerVisible} isDrawerVisible={isDrawerVisible} userDetails={userDetails} setUserDetails={setUserDetails}/>}></Route>
          
          
          <Route path='/play/:id' element={<VedioPlayer userDetails={userDetails} setUserDetails={setUserDetails} />}></Route>
          <Route path='/home' element={<WorkingonIt/>}></Route>
          <Route path='*' element={<PageNotFound/>}></Route>
       
          <Route path='/subs' element={<SubscriptionPage/>}></Route>
          <Route path='/shorts' element={<WorkingonIt/>}></Route>
          <Route path='/playlist' element={<WorkingonIt/>}></Route>
          <Route path='/about' element={<AboutPage/>}></Route>
          
          <Route path='/settings' element={<Settings/>}></Route>
          
          {/* <Route path='/contact' element={<ContactInfo/>}></Route> */}
       
          <Route path='/channel/:id' element={<ChannelDetails/>}></Route>
          <Route path='/watch-h' element={<WatchHistory/>}></Route>
          <Route path='/watch-f' element={<FavoriteVideos/>}></Route>
          <Route path='/watch-l' element={<WatchLater/>}></Route>
          <Route path='/watch-s' element={<WorkingonIt/>}></Route>
          <Route path='/contact' element={<Contact/>}></Route>
   
          <Route path='/channelDetail/:id' element={<WorkingonIt/>}></Route>
          <Route path='/userdetails' element={<UserDetailFrom setPopupVisible={setPopupVisible}/>}></Route>
          <Route path='/details' element={<InitialPopup setPopupVisible={setPopupVisible} PopupVisible={PopupVisible}/>}></Route>
          
      </Routes>

      
   </BrowserRouter>
   </>
   
   
  );
}

export default App;
